import React from "react";

import { Box } from "../../../../../../../../mads";
import { Text } from "../../../../../../../../mads/Text";
import { styles } from "../HighlightedAttributes/styles";

interface SingleLineItemsProps {
  fieldMap: Record<string, string[]>;
}

export const SingleLineItems = ({ fieldMap }: SingleLineItemsProps) => {
  const fieldMapKeys = Object.keys(fieldMap || {});
  if (fieldMapKeys.length === 0) {
    return null;
  }
  return (
    <>
      {fieldMapKeys.map((key) => {
        const valueList = fieldMap[key];

        return (
          <Box key={key} sx={styles.sectionContentPreferenceMatch}>
            <Text sx={styles.sectionItemKey}>{key}</Text>
            {valueList.map((value) => {
              return (
                <Text key={value} sx={{ display: "flex" }}>
                  {value}
                </Text>
              );
            })}
          </Box>
        );
      })}
    </>
  );
};
